const CirculoTildeOk = ({width, height, color, white, stroke}) => {
    return (
      <svg
        width={width ? width: "37"}
        height={height ? height: "37"}
        viewBox="0 0 37 37"
        fill={color ? color: "none"}
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="18.5" cy="18.5" r="17" stroke="#3D994A" strokeWidth="3" />
        <path
          d="M9.92639 18.9499L15.341 24.8157L27.0727 12.6328"
          stroke={white ? white : "#3D994A"}
          strokeWidth={stroke ? stroke : "3"}
        />
      </svg>
    );
  };
  
  export default CirculoTildeOk;